import { http } from "../api";
import { ApiResponse } from "../interfaces/response";
import { AnalysisRating } from "../model/AnalysisRating";

const controller = '/rating';

type FilterParams = {
  page: number;
  limit: number;
  order?: string;
  startDate?: string;
  endDate?: string;
};

function buildQuery(params: FilterParams) {
  const query = Object.keys(params)
    .filter(key => params[key as keyof FilterParams] !== undefined)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key as keyof FilterParams] as string)}`)
    .join('&');
  return query ? `?${query}` : '';
}

export async function getAll(params: FilterParams): Promise<ApiResponse<AnalysisRating>> {
  const query = buildQuery(params);
  const { data } = await http.get<ApiResponse<AnalysisRating>>(`${controller}${query}`);
  return data;
}

export async function getByDepartment(id: string, params: FilterParams): Promise<ApiResponse<AnalysisRating>> {
  const query = buildQuery(params);
  const { data } = await http.get<ApiResponse<AnalysisRating>>(`${controller}/department/${id}${query}`);
  return data;
}

export async function getByCategory(id: string, params: FilterParams): Promise<ApiResponse<AnalysisRating>> {
  const query = buildQuery(params);
  const { data } = await http.get<ApiResponse<AnalysisRating>>(`${controller}/category/${id}${query}`);
  return data;
}

export async function getByActivity(id: string, params: FilterParams): Promise<ApiResponse<AnalysisRating>> {
  const query = buildQuery(params);
  const { data } = await http.get<ApiResponse<AnalysisRating>>(`${controller}/activity/${id}${query}`);
  return data;
}
